import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserService = sdk.getService('UserService');

export const useUserAcademies = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['user', 'academies'],
    queryFn: () => UserService.getUserAcademies()
  });

  return { academies: data, isLoading, error };
};
